import { Component, Inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { CartResponseData, CartItem } from '../../../../core/models/order-payload.model';
import { OrderProcessingService } from '../../../../core/services/order-processing';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.html',
    styleUrl: './cart.scss',
})
export class Cart implements OnInit {
    cartData = signal<CartResponseData | null>(null);

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private router: Router,
        private orderProcessing: OrderProcessingService
    ) {}

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            const savedCart = localStorage.getItem('cart_response');
            if (savedCart) {
                try {
                    const parsed = JSON.parse(savedCart);
                    if (parsed && parsed.data) {
                        this.cartData.set(parsed.data);
                    }
                } catch (e) {
                    console.error('Failed to parse cart_response from local storage', e);
                }
            }
        }
    }

    goBack(): void {
        this.router.navigate(['/']);
    }

    moveForward(): void {
        this.router.navigate(['/order-form']);
    }

    removeItem(item: CartItem): void {
        const id = item.id;
        if (id === undefined) {
            console.error('No cartItemId or id found on cart item:', item);
            return;
        }

        const currentData = this.cartData();

        this.orderProcessing.deleteItemFromCart(id).then(
            (response) => {
                let isEmpty = false;
                if (response && response.data) {
                    this.cartData.set(response.data);
                    if (!response.data.cartItems || response.data.cartItems.length === 0) {
                        isEmpty = true;
                    }
                } else {
                    // Fallback logic if the response does not return updated cart data
                    if (currentData) {
                        const updatedItems = currentData.cartItems.filter(i => i.id !== id);
                        if (updatedItems.length === 0) {
                            isEmpty = true;
                        } else {
                            const updatedData = {
                                ...currentData,
                                cartItems: updatedItems
                            };
                            this.cartData.set(updatedData);
                            localStorage.setItem('cart_response', JSON.stringify({ data: updatedData }));
                        }
                    }
                }

                if (isEmpty) {
                    this.cartData.set(null);
                    localStorage.removeItem('cart_response');
                    localStorage.removeItem('shipping_response');
                    const requestNumber = response?.data?.requestNumber || currentData?.requestNumber;
                    if (requestNumber) {
                        this.orderProcessing.destroyCart(requestNumber).then(
                            () => {},
                            (destroyErr) => {
                                console.error('Failed to destroy cart:', destroyErr);
                            }
                        );
                    }
                }
            },
            (error) => {
                console.error('Failed to remove item from cart:', error);
                alert('Error removing item from cart. Please try again.');
            }
        );
    }
}
